import Api from './operations';
import { types } from './types';
export function load() {
  return function(dispatch) {
    if (!localStorage.getItem('token')) {
      return dispatch(unauthorized());
    }
    return Api.getDocuments()
      .then(response => {
        switch (response.statusCode) {
          case 400:
          case 404:
          case 409:
          case 401:
            dispatch(unauthorized());
            break;
          case 201:
          case 200:
            dispatch(loadSuccess(response.data));
            break;
          default:
            dispatch(
              loadFailed(
                'Could not load documents. Code:' + response.statusCode
              )
            );
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(loadFailed('Unhandled error'));
        throw error;
      });
  };
}
export function loadSuccess(data) {
  return { type: types.LOAD_SUCCESS, data: data };
}
export function loadFailed(error) {
  return { type: types.LOAD_FAILED, error: error };
}
export function unauthorized() {
  localStorage.removeItem('token');
  return { type: types.UNAUTHORIZED };
}
export function clearError() {
  return { type: types.CLEAR_ERROR };
}



// WEBPACK FOOTER //
// ./src/components/F1095C/ducks/actions.js